export const todayISO = () => new Date().toISOString().slice(0, 10);

export const daysAgoISO = (days) => {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString().slice(0, 10);
};

export const monthStartISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
};

export const defaultReportRange = (periodType) =>
  periodType === 'weekly'
    ? { from: daysAgoISO(6), to: todayISO() }
    : { from: monthStartISO(), to: todayISO() };

export const filterByDateRange = (items, from, to, dateKey = 'date') => {
  if (!from && !to) return [...items];
  return items.filter((item) => {
    const value = item[dateKey];
    if (!value) return false;
    if (from && value < from) return false;
    if (to && value > to) return false;
    return true;
  });
};

export const validateDateRange = (from, to) => {
  if (!from || !to) return 'Please select both start and end dates.';
  if (from > to) return 'Start date must be before end date.';
  return null;
};
